import React, {useEffect, useState} from 'react';
import { withRouter } from 'react-router-dom';
import { getDetailProductSetting } from "../../helpers/getDetailProductSetting";
import ClayModal, { useModal } from '@clayui/modal';
import ClayPanel from '@clayui/panel';
import {ClayCheckbox} from '@clayui/form';
import ClayButton from '@clayui/button';
import ClayForm, {ClayInput, ClaySelect} from '@clayui/form';
import ClayIcon from '@clayui/icon';
import {saveDetailProductSetting} from "../../helpers/saveDetailProductSetting";
import { getProductGroups } from "../../helpers/getProductGroups"; 

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export default withRouter(({history, match: {params: { detailProductId }}}) => {

    const [detailProductSetting, setDetailProductSetting] = useState(null);
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        getDetailProductSetting(detailProductId).then(data => {
            setDetailProductSetting(data);
        })
        
        getProductGroups().then(data => {
            setGroups(data);
        });

    }, [detailProductId]);

    const onGoBack = () => {
        history.goBack();
    }

    const getGroupName = (groupCode) => {
        return groups.find(item => item.childCode === groupCode)?.childName || groupCode;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(document.getElementById('formUpdateCard'));

        saveDetailProductSetting(
            detailProductSetting.id, 
            detailProductSetting.group,
            formData.get("nameProduct"),
            formData.get("productCode"),
            formData.get("description"),
            formData.get("srcImage"),
            formData.get("urlRedirect"),
            formData.get("buttonURL"),
            formData.get("client") === 'true',
            formData.get("noClient") === 'true',
            formData.get("order"),
            formData.get("contentIDBanner")
        ).then(myobjet => {
            history.goBack();
        });
    }

    return (
        <>
            {
                detailProductSetting && (
                    <div>
                        <form id="formUpdateCard" onSubmit={handleSubmit}>
                            <ClayModal.Body>
                                <ClayForm.Group>
                                    <ClayInput.Group>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="productCode">Nombre Grupo
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClaySelect name="productGroup" id="type" defaultValue={detailProductSetting.group}>
                                                {
                                                    detailProductId === '0' ? (
                                                        <>
                                                            <ClaySelect.Option label="Seleccione" value='' />
                                                            {
                                                                groups.map(item => (
                                                                    <ClaySelect.Option
                                                                        key={item.childCode}
                                                                        label={item.childName}
                                                                        value={item.childCode}
                                                                    />
                                                                ))
                                                            }
                                                        </>
                                                    ) : 
                                                    <ClaySelect.Option
                                                        key={detailProductSetting.group}
                                                        label={getGroupName(detailProductSetting.group)}
                                                        value={detailProductSetting.group}
                                                    />
                                                }
                                            </ClaySelect>
                                        </ClayInput.GroupItem>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="nameProduct">Orden
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.order} name="order" id='order' />
                                        </ClayInput.GroupItem>
                                    </ClayInput.Group>
                                </ClayForm.Group>
                                <ClayForm.Group>
                                    <ClayInput.Group>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="nameProduct">Nombre Card
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.name} name="nameProduct" id='nameProduct' />
                                        </ClayInput.GroupItem>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="description">Descripción
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.description} name="description" id='description' />
                                        </ClayInput.GroupItem>
                                    </ClayInput.Group>
                                </ClayForm.Group>
                                <ClayForm.Group>
                                    <ClayInput.Group>
                                        { detailProductSetting.group == 'PRESTAMOS_CREDITOS' && (
                                            <ClayInput.GroupItem>
                                                <label htmlFor="productCode">Código Producto
                                                    <span className="reference-mark">
                                                        <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                    </span>
                                                </label>
                                                <ClayInput type="text" defaultValue={detailProductSetting.productCode} name="productCode" id='productCode' />
                                            </ClayInput.GroupItem>
                                        )}
                                        <ClayInput.GroupItem>
                                            <label htmlFor="srcImage">Path Imagen
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.srcImage} name="srcImage" id='srcImage' />
                                        </ClayInput.GroupItem>
                                    </ClayInput.Group>
                                </ClayForm.Group>
                                <ClayForm.Group>
                                    <ClayInput.Group>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="urlRedirect">Link Redirect
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.URL} name="urlRedirect" id='urlRedirect' />
                                        </ClayInput.GroupItem>
                                        <ClayInput.GroupItem>
                                            <label htmlFor="buttonURL">Link Redirect Botón Verde
                                                <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                            </label>
                                            <ClayInput type="text" defaultValue={detailProductSetting.buttonURL} name="buttonURL" id='buttonURL' />
                                        </ClayInput.GroupItem>
                                    </ClayInput.Group>
                                </ClayForm.Group>
                                
                                { detailProductSetting.group == 'PRESTAMOS_CREDITOS' && (
                                    <ClayForm.Group>
                                        <ClayInput.Group>
                                            <ClayInput.GroupItem className="col-6">
                                                <label htmlFor="contentIDBanner">Id Contenido Banner
                                                    <span className="reference-mark">
                                                    <ClayIcon spritemap={window.$spritemap} symbol="asterisk" />
                                                </span>
                                                </label>
                                                <ClayInput type="text" defaultValue={detailProductSetting.contentIDBanner} name="contentIDBanner" id='contentIDBanner' />
                                            </ClayInput.GroupItem>
                                        </ClayInput.Group>
                                    </ClayForm.Group>
                                )}

                                { detailProductSetting.group == 'SEGUROS' && (
                                    <ClayPanel
                                        displayTitle="Cliente"
                                        displayType="secondary"
                                        spritemap={window.$spritemap}
                                        defaultExpanded
                                    >
                                        <ClayPanel.Body>
                                            <ClayForm.Group>
                                                <ClayInput.Group>
                                                    <ClayInput.GroupItem>
                                                        <div className="form-check">
                                                            <ClayCheckbox
                                                                defaultChecked={detailProductSetting.client}
                                                                name="client"
                                                                id="client"
                                                                value="true"
                                                                label={'Cliente'}
                                                            />
                                                        </div>
                                                    </ClayInput.GroupItem>
                                                    <ClayInput.GroupItem>
                                                        <div className="form-check">
                                                            <ClayCheckbox
                                                                defaultChecked={detailProductSetting.noClient}
                                                                name="noClient"
                                                                id="noClient"
                                                                value="true"
                                                                label={'No Cliente'}
                                                            />
                                                        </div>
                                                    </ClayInput.GroupItem>
                                                </ClayInput.Group>
                                            </ClayForm.Group>
                                        </ClayPanel.Body>
                                    </ClayPanel>
                                )}
                            </ClayModal.Body>
                            <ClayModal.Footer
                                first={
                                    <ClayButton.Group spaced>
                                        <ClayButton displayType="secondary" onClick={onGoBack} >{"Cancelar"}</ClayButton>
                                    </ClayButton.Group>
                                }
                                last={<ClayButton type="submit">{"Guardar"}</ClayButton>}
                            />
                        </form>
                    </div>
                )
            }
        </>
    )
})
